import './AppSelect.scss';
import { AppDisplay } from '.';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { getDirectParent } from '@lib/popups';
import { Select } from 'antd';
import sortBy from 'lodash/sortBy';
import { stringContainsSubstringCaseInsensitive } from '@sonar-software/sonar-ts-lib';
import { useDataSecurityApps } from '@hooks';
import React, { useMemo } from 'react';
export const appSelectors = createAsyncSelectors((state) => state.core.dataSecurity.applications.get);
export const AppSelect = ({ getPopupContainer, includeDetected, nameAndLabel, onChange, placeholder, value }) => {
    const apps = useDataSecurityApps(false, includeDetected);
    const options = useMemo(() => sortBy(apps.map((app) => ({
        label: React.createElement(AppDisplay, { appId: app.applicationId }),
        optionLabel: `${app.name}${nameAndLabel && app.label ? ` - ${app.label}` : ''}`,
        value: app.applicationId
    })), (app) => app.label), [apps, nameAndLabel]);
    const handleFilter = (input, option) => stringContainsSubstringCaseInsensitive(option === null || option === void 0 ? void 0 : option.optionLabel, input);
    return (React.createElement(Select, { allowClear: true, className: 'app-select', classNames: {
            popup: {
                root: 'app-select-dropdown'
            }
        }, filterOption: handleFilter, getPopupContainer: getPopupContainer !== null && getPopupContainer !== void 0 ? getPopupContainer : getDirectParent, onChange: onChange, optionFilterProp: 'label', optionLabelProp: 'optionLabel', options: options !== null && options !== void 0 ? options : [], placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : COPY_SPECIFIC.APPLICATION, showSearch: true, value: value }));
};
